import { useTooltip } from "./HelpTooltip";

type Props = {
  text: string | null | undefined;
  /** Ile znaków pokazać w wierszu; reszta idzie do dymka. */
  previewLength?: number;
  /** Co pokazać zamiast pustej wartości. */
  empty?: string;
};

/**
 * Komórka tabeli z długim tekstem: w wierszu skrót, pełna treść w dymku po najechaniu myszką
 * (na dotyku po kliknięciu). Bez tego kontekst z CRM — a bywa i na 1500 znaków — kończył się
 * wielokropkiem i nie było jak go doczytać, nie wchodząc do CRM-u.
 *
 * Krótkie wartości dymka nie dostają, bo powtarzałby to, co i tak widać w wierszu.
 */
export function TableCellText({ text, previewLength = 160, empty = "-" }: Props) {
  const full = text?.trim() ?? "";
  if (!full) return <>{empty}</>;
  if (full.length <= previewLength) return <>{full}</>;
  return <TruncatedCellText full={full} previewLength={previewLength} />;
}

function TruncatedCellText({ full, previewLength }: { full: string; previewLength: number }) {
  const { triggerRef, triggerProps, renderTooltip } = useTooltip({ wide: true });

  return (
    <>
      <span ref={triggerRef} className="cell-text-trigger" tabIndex={0} {...triggerProps}>
        {`${full.slice(0, previewLength)}…`}
      </span>
      {renderTooltip(full)}
    </>
  );
}
